import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.437 4h-.859V2.75c0-.597-.272-1.169-.755-1.591A2.78 2.78 0 0 0 5 .5a2.78 2.78 0 0 0-1.823.659c-.484.422-.755.994-.755 1.591V4h-.86c-.304 0-.595.105-.81.293A.94.94 0 0 0 .417 5v4.5c0 .265.12.52.335.707.215.188.506.293.81.293h6.875c.304 0 .596-.105.81-.293a.94.94 0 0 0 .336-.707V5a.94.94 0 0 0-.335-.707A1.24 1.24 0 0 0 8.438 4M5.573 8a.47.47 0 0 1-.168.354A.62.62 0 0 1 5 8.5a.62.62 0 0 1-.405-.146A.47.47 0 0 1 4.427 8V6.5c0-.133.06-.26.168-.354A.62.62 0 0 1 5 6c.152 0 .298.053.405.146a.47.47 0 0 1 .168.354zm.86-4H3.567V2.75c0-.332.15-.65.419-.884A1.55 1.55 0 0 1 5 1.5c.38 0 .744.132 1.013.366.268.235.42.552.42.884z"
    }, null, -1)
  ])))
}
export default { render: render }